import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=be397664&"
import script from "./TablePagination.vue?vue&type=script&lang=ts&"
export * from "./TablePagination.vue?vue&type=script&lang=ts&"
import style0 from "./TablePagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports